import React from 'react';
import { motion } from 'framer-motion';

const FaqPage = () => {
  const perguntas = [
    {
      pergunta: 'Quais formas de pagamento são aceitas?',
      resposta: 'Os pagamentos são processados com segurança através dos métodos disponíveis no checkout da loja.'
    },
    {
      pergunta: 'Qual é o prazo de entrega?',
      resposta: 'O prazo de entrega varia conforme a sua região e será informado no momento da compra.'
    },
    {
      pergunta: 'Posso trocar ou devolver um produto?',
      resposta: 'Sim. Caso precise, entre em contato conosco para analisarmos seu caso e orientarmos da melhor forma.'
    },
    {
      pergunta: 'Como entro em contato com a loja?',
      resposta: 'Você pode usar nossa página de contato ou enviar e-mail diretamente para nosso atendimento.'
    }
  ];

  return (
    <div className="min-h-screen pt-24 pb-16 px-6">
      <div className="max-w-[1000px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-12"
        >
          <h1 className="font-heading text-5xl font-bold text-text-primary mb-4">
            FAQ
          </h1>
          <p className="text-lg text-text-secondary">
            Perguntas frequentes sobre a Aura Rosa.
          </p>
        </motion.div>

        <div className="bg-white rounded-2xl shadow-sm p-8 md:p-10 space-y-8">
          {perguntas.map((item, index) => (
            <div key={index} className="border-b border-stone-100 pb-6 last:border-b-0 last:pb-0">
              <h2 className="font-heading text-2xl font-bold text-text-primary mb-3">
                {item.pergunta}
              </h2>
              <p className="text-text-secondary text-lg leading-relaxed">
                {item.resposta}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FaqPage;